import React, { PureComponent, Fragment } from 'react';
import Numeral from 'numeral';
import moment from 'moment';
import IframePrint from '../../../../components/UI/IframePrint/IframePrint';

const fontStyles = { fontSize: '14px', fontFamily: 'monospace' };
const paragraphStyles = { lineHeight: '1.5' };

class ComponentToPrint extends PureComponent {
    render() {
        const {
            repartidor,
            empresa,
            sucursal,
            callCenter,
            artefactos
        } = this.props;

        const htmlTicket = <div style={{ width: "300px", maxWidth: "300px" }}>
            <CopiaRepartidor titulo="Copia para el Repartidor" repartidor={repartidor} sucursal={sucursal} empresa={empresa} callCenter={callCenter} />
            {
                artefactos.copiaCaja ?
                    <Fragment>
                        <hr style={{ borderStyle: "dashed" }} />
                        <CopiaRepartidor titulo="Copia para la Caja" repartidor={repartidor} sucursal={sucursal} empresa={empresa} callCenter={callCenter} />
                    </Fragment>
                    : ""
            }
            {
                artefactos.imprimirDetalle ?
                    <Fragment>
                        <hr style={{ borderStyle: "dashed" }} />
                        <DetalleOrden sucursal={sucursal} repartidor={repartidor} empresa={empresa} callCenter={callCenter} />
                    </Fragment>
                    : ""
            }
            <p style={{ ...fontStyles, textAlign: 'center', marginTop: '1.5rem' }}>----- Última Línea -----</p>
        </div>;
        return (
            <Fragment>
                {htmlTicket}
                <IframePrint id={this.props.printId} reactElement={htmlTicket} />
            </Fragment>
        );
    }
}

class CopiaRepartidor extends PureComponent {
    render() {
        const { titulo, repartidor, empresa, sucursal } = this.props;
        let _ordenesNoRuta = repartidor.Ordenes;

        return (
            <Fragment>
                <div style={{ ...fontStyles, textAlign: "center" }}>
                    <p style={paragraphStyles}>
                        <b>{titulo}</b><br />
                        <b>{empresa.Nombre}</b>
                    </p>
                </div>
                <div style={fontStyles}>
                    <p style={paragraphStyles}>
                        {sucursal.Nombre}<br />
                        SALIDA DE REPARTIDOR(Resumen)<br />
                        Repartidor: {repartidor.Nombre}<br />
                        Fecha: {moment(new Date()).format("D/MM/YYYY, HH:mm:ss A")}
                    </p>
                </div>

                <table style={{ ...fontStyles, width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: "right" }}>Orden</th>
                            <th style={{ textAlign: "center" }}>Tipo</th>
                            <th style={{ textAlign: "right" }}>Monto</th>
                            <th style={{ textAlign: "right" }}>Cambio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            repartidor ?
                                _ordenesNoRuta.map(orden => {
                                    return <tr>
                                        <td style={{ textAlign: "right" }}>{orden.Id}</td>
                                        <td style={{ textAlign: "center" }}>{orden.Tipo_Pago.Tipo}</td>
                                        <td style={{ textAlign: "right" }}>{orden.Tipo_Pago.Tipo === "RE" ? "0.00" : Numeral(orden.Monto.Valor).format('0,0.00')}</td>
                                        <td style={{ textAlign: "right" }}>{orden.Tipo_Pago.Contado ? Numeral(orden.Cambio).format('0,0.00') : "0.00"}</td>
                                    </tr>
                                })
                                : ""
                        }
                    </tbody>
                </table>
                <table style={{ ...fontStyles, width: '100%', marginTop: '2rem' }}>
                    <tbody>
                        <tr>
                            <td colSpan="2">Total CO:</td>
                            <td style={{ textAlign: "right" }}>
                                {Numeral(_ordenesNoRuta.map(orden => { return orden.Tipo_Pago.Contado ? orden.Monto.Valor : 0 }).reduce((total, cantidad) => { return total + cantidad })).format('0,0.00')}
                            </td>
                            <td style={{ textAlign: "right" }}>
                                {Numeral(_ordenesNoRuta.map(orden => { return orden.Tipo_Pago.Contado ? orden.Cambio : 0 }).reduce((total, cantidad) => { return total + cantidad })).format('0,0.00')}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">Total CR:</td>
                            <td style={{ textAlign: "right" }}>
                                {Numeral(_ordenesNoRuta.map(orden => { return orden.Tipo_Pago.Credito ? orden.Monto.Valor : 0 }).reduce((total, cantidad) => { return total + cantidad })).format('0,0.00')}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">Valores:</td>
                            <td style={{ textAlign: "right" }}>
                                {Numeral(_ordenesNoRuta.map(orden => { return ((orden.Tipo_Pago.Tipo !== "RE") && (orden.Tipo_Pago.Tipo !== "CR")) ? orden.Monto.Valor + orden.Cambio : 0 }).reduce((total, cantidad) => { return total + cantidad })).format('0,0.00')}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ ...fontStyles, textAlign: 'center', marginTop: '3rem' }}>
                    <hr style={{ borderWidth: "1px", borderStyle: "solid", width: '50%' }} />
                    <p style={paragraphStyles}>Firma Repartidor</p>
                </div>
            </Fragment>
        )
    }
}

class DetalleOrden extends PureComponent {
    render() {
        const { repartidor, empresa, sucursal } = this.props;

        const detalleHtml = repartidor && repartidor.Ordenes && repartidor.Ordenes.length > 0 ?
            repartidor.Ordenes.map((orden, index) => {
                let sucursales = [];
                for (let i = 0; i < orden.Productos.length; i++) {
                    let sucursal = { Id: orden.Productos[i].Suc_Id, Nombre: orden.Productos[i].Suc_Nombre };
                    //  Primera iteración
                    if (i === 0) {
                        sucursales.push(sucursal);
                    } else {
                        //  La sucursal no existe en el arreglo
                        const filtered = sucursales.filter(suc => suc.Id === sucursal.Id);
                        if(!filtered || filtered.length === 0)
                        {
                            sucursales.push(sucursal);
                        }
                    }
                }

                return (
                    <Fragment>
                        {
                            index > 0 ?
                                <hr style={{ borderWidth: "1px", borderStyle: "dashed", marginTop: '2rem' }} />
                                : null
                        }
                        <div style={{ ...fontStyles, marginTop: '2rem' }}>
                            <p style={paragraphStyles}>
                                <b>Orden: {orden.Id}</b><br />
                                {orden.Tipo_Pago.Tipo === "RE" ? <Fragment>REGALÍA<br /></Fragment> : ""}
                                Teléfono: {orden.Telefono}<br />
                                Nombre: {orden.Cliente}<br />
                                Nombre Ubicación: {orden.Ubicacion_Nombre}<br />
                                {orden.Nivel1}<br />
                                {orden.Nivel2}<br />
                                {orden.Nivel3}<br />
                                {orden.Nivel4}<br />
                                Dirección: {`${orden.Ubicacion_Referencia}, ${orden.Ubicacion_Direccion}`}<br />
                                Localidad: {orden.Ubicacion_Localidad === "C" ? "Casa" : orden.Ubicacion_Localidad === "E" ? "Empresa" : orden.Ubicacion_Localidad}<br />
                                Observaciones: {orden.Observaciones}
                            </p>
                            <div style={{ textAlign: 'center' }}>
                                <hr style={{ borderWidth: "1px", borderStyle: "dashed", width: '50%' }} />
                            </div>
                            <p style={paragraphStyles}>
                                Sucursal de Retiro<br />
                            </p>
                            <table style={{ ...fontStyles, width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left" }}>Artículo</th>
                                        <th style={{ textAlign: "right" }}>Cantidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sucursales && sucursales.length > 0 ?
                                            sucursales.map((sucursal) => {

                                                const productosHtml = orden.Productos.map(producto => {
                                                    if (producto.Suc_Id === sucursal.Id && producto.Detalle_Facturar > 0) {
                                                        return <tr>
                                                            <td>
                                                                {`${producto.Articulo_Codigo_Principal ? producto.Articulo_Codigo_Principal : producto.Articulo_Id} - ${producto.Articulo_Nombre}`}
                                                            </td>
                                                            <td style={{ textAlign: "right" }}>
                                                                {producto.Detalle_Facturar}
                                                            </td>
                                                        </tr>;
                                                    }
                                                });

                                                return <Fragment>
                                                    <tr>
                                                        <td colSpan={2}><b>{sucursal.Nombre}</b></td>
                                                    </tr>
                                                    {productosHtml}
                                                </Fragment>
                                            })
                                            : null
                                    }
                                </tbody>
                            </table>
                        </div >
                    </Fragment>
                )
            })
            : null;

        return (
            <Fragment>
                <div style={{ ...fontStyles, textAlign: "center" }}>
                    <p style={paragraphStyles}><b>{empresa.Nombre}</b></p>
                </div>
                <div style={fontStyles}>
                    <p style={paragraphStyles}>
                        {sucursal.Nombre}<br />
                        SALIDA DE REPARTIDOR(Distribución)<br />
                        Repartidor: {repartidor.Nombre}<br />
                        Fecha: {moment(new Date()).format("D/MM/YYYY, HH:mm:ss A")}
                    </p>
                </div>
                { detalleHtml}
            </Fragment >
        )
    }
}

export default ComponentToPrint;